"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoPurchasePlanStatementBalanceAndMinDuesReason = void 0;
var NoPurchasePlanStatementBalanceAndMinDuesReason;
(function (NoPurchasePlanStatementBalanceAndMinDuesReason) {
    NoPurchasePlanStatementBalanceAndMinDuesReason["accountHasNoNonPurchasePlans"] = "accountHasNoNonPurchasePlans";
    NoPurchasePlanStatementBalanceAndMinDuesReason["calculationError"] = "calculationError";
})(NoPurchasePlanStatementBalanceAndMinDuesReason || (exports.NoPurchasePlanStatementBalanceAndMinDuesReason = NoPurchasePlanStatementBalanceAndMinDuesReason = {}));
